import { ConnectComponent } from '../_components/ConnectComponent'
import { ContactMePresenter } from './ContactMe.presenter'
import { ContactMeView } from './ContactMe.view'

export const ContactMe = ConnectComponent(ContactMeView, ContactMePresenter)
